/* global evina_notify */

import React, { useState } from "react";
import { Form, Button, Select } from "antd";

const ShowPack = ({ packSubmit, evinaData, isFrench, isBoxChecked }) => {
  const { Option } = Select;
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const evinaNotify = typeof evina_notify !== "undefined" ? evina_notify : null;
  console.log("EVIBA TYPE", evinaNotify)

  
  const handleClick = (e) => {
    setLoading(true);
    const evinaNotify = typeof evina_notify !== "undefined" ? evina_notify : null;
    console.log("evinaNotify function:", typeof evinaNotify);

    if (typeof evinaNotify === "function") {
      console.log("evinaNotify exists, verifying...");

      // Timeout fallback if Evina doesn't call back
      const evinaTimeout = setTimeout(() => {
        console.warn("[Evina] ❌ Timeout! Callback not fired within 5 seconds. Calling packSubmit anyway.");
        form
          .validateFields()
          .then((values) => {
            packSubmit(values, evinaData);
              setLoading(false);
          })
          .catch((info) => {
            console.error("Validation Failed (timeout path):", info);
            setLoading(false);
          });
      }, 5000);

      evinaNotify(e, function (result) {
        clearTimeout(evinaTimeout);
        console.log("[Evina] ✅ Callback received with result:", result);

        form
          .validateFields()
          .then((values) => {
            packSubmit(values, evinaData);
          })
          .catch((info) => {
            console.error("Validation Failed:", info);
          });
      });
    } else {
      console.warn("evinaNotify is not defined yet, triggering DCBProtectRun event again...");
      const ev = new Event("DCBProtectRun");
      document.dispatchEvent(ev);

      console.warn("Fallback: calling packSubmit anyway (Evina might be delayed)");
      form
        .validateFields()
        .then((values) => {
          packSubmit(values, evinaData);
          setLoading(false);
        })
        .catch((info) => {
          console.error("Validation Failed:", info);
          setLoading(false);
        });
    }
  };

  const onPackChange = (value) => {
    switch (value) {
      case "daily":
        form.setFieldsValue({
          pack: isFrench ? "Toonflix quotidien" : "تونفليكس ديلي",
        });
        break;
      case "weekly":
        form.setFieldsValue({
          pack: isFrench ? "Toonflix hebdomadaire" : "تونفليكس ويكلي",
        });
        break;
      default:
        break;
    }
  };

  return (
    <Form
      form={form}
      name="form-field"
      // initialValues={{ remember: true }}
      autoComplete="off"
      initialValues={{ pack: "daily" }}

    >
      <Form.Item
        name="pack"
        label={isFrench ? "Selectionner le pack" : "حدد الباقة"}
        rules={[{ required: true }]}
      >
        <Select
          placeholder={isFrench ? "Selectionner le pack" : "حدد الباقة"}
          onChange={onPackChange}
          allowClear
          disabled={loading}
        >
          <Option value="daily">
            {isFrench
              ? "25 dinars Algerien par jour"
              : "25 دينار جزائري في اليوم"}
          </Option>
          <Option value="weekly">
            {isFrench
              ? "100 dinars Algerien par semaine"
              : "100 دينار جزائري كل أسبوع"}
          </Option>
        </Select>
      </Form.Item>

      <Button
        id="cta_button"
        className="custom-button"
        size="large"
        type="primary"
        htmlType="button"
         loading={loading}
        onClick={(e) => handleClick(e.nativeEvent)}
        // disabled={!isBoxChecked}
         disabled={!isBoxChecked || loading} 
      >
        {isFrench ? "s'abonner" : "اشترك"}
      </Button>
    </Form>
  );
};

export default ShowPack;









// import React, { useState } from "react";
// import { Form, Button, Select } from "antd";

// const ShowPack = ({ packSubmit, isFrench, isBoxChecked }) => {
//   const { Option } = Select;
//   const [loading, setLoading] = useState(false);
//   const onGenderChange = (value) => {
//     switch (value) {
//       case "daily":
//         form.setFieldsValue({
//           pack: isFrench ? "Toonflix quotidien" : "تونفليكس ديلي",
//         });
//         return;

//       case "weekly":
//         form.setFieldsValue({
//           pack: isFrench ? "Toonflix hebdomadaire" : "تونفليكس ويكلي",
//         });
//         return;
//     }
//   };
//   const [form] = Form.useForm();
//   return (
//     <Form
//       form={form}
//       name="form-field"
//       initialValues={{
//         remember: true,
//       }}
//       // onFinish={onFinishOTP}
//       onFinish={packSubmit}
//       autoComplete="off"
//     >
//       <Form.Item
//         name="pack"
//         label={`${isFrench ? "Selectionner le pack" : "حدد الباقة"}`}
//         rules={[
//           {
//             required: true,
//           },
//         ]}
//       >
//         <Select
//           placeholder={`${isFrench ? "Selectionner le pack" : "حدد الباقة"}`}
//           onChange={onGenderChange}
//           allowClear
//           disabled={loading ? true : false}
//         >
//           <Option value="daily">{`${
//             isFrench
//               ? "25 dinars Algerien par jour"
//               : "25 دينار جزائري في اليوم"
//           }`}</Option>

//           <Option value="weekly">{`${
//             isFrench
//               ? "100 dinars Algerien par semaine"
//               : "100 دينار جزائري كل أسبوع"
//           }`}</Option>
//         </Select>
//       </Form.Item>
//       <Button
//         className="custom-button"
//         size="large"
//         type="primary"
//         htmlType="submit"
//         // onClick={formSubmit}
//         // style={{ textAlign: "center" }}
//       >
//         {`${isFrench ? "s'abonner" : "اشترك"}`}
//       </Button>
//     </Form>
//   );
// };

// export default ShowPack;
